var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrengthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#00A92A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9619 11.025H9.82441L7.74316 6H9.88066L11.9619 11.025Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0372 11.025H14.1747L16.256 6H14.1185L12.0372 11.025Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 18.0001C14.4755 18.0001 16.4818 15.9938 16.4818 13.5188C16.4818 11.0439 14.4755 9.0376 12.0005 9.0376C9.52561 9.0376 7.51929 11.0439 7.51929 13.5188C7.51929 15.9938 9.52561 18.0001 12.0005 18.0001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5919 14.4094C16.0875 12.4305 14.885 10.4245 12.9061 9.92892C10.9272 9.43333 8.92127 10.6358 8.42567 12.6147C7.93008 14.5935 9.13253 16.5995 11.1114 17.0951C13.0903 17.5907 15.0963 16.3883 15.5919 14.4094Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 16.894C13.8646 16.894 15.3756 15.383 15.3756 13.519C15.3756 11.6551 13.8646 10.144 12.0006 10.144C10.1366 10.144 8.62561 11.6551 8.62561 13.519C8.62561 15.383 10.1366 16.894 12.0006 16.894Z",
    fill: "#00A92A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 11.5308L12.4508 12.9183H13.9133L12.732 13.7808L13.182 15.1683L12.0008 14.3058L10.8195 15.1683L11.2695 13.7808L10.0883 12.9183H11.5508L12.0008 11.5308Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrengthIcon);
export default __webpack_public_path__ + "static/media/StrengthIcon.7362c4b36ad2ef71d01560756155a55e.svg";
export { ForwardRef as ReactComponent };